// import * as React from 'react';
// import {useState, useCallback} from 'react';
// import {render} from 'react-dom';
// import Map from 'react-map-gl';
// import ControlPanel from './MapLayoutControls';
// import './map.css';
// import Pin from './MapPin';

// const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGhhbmVlc2h0bmFpciIsImEiOiJjajN2OXU3b2IwMTRuMnlsYmRhandwdWV0In0.PhXxSGpmy4fXeO4tbfQ9Yg'; // Set your mapbox token here

// const initialViewState = {
//   latitude: 37.729,
//   longitude: -122.36,
//   zoom: 11,
//   bearing: 0,
//   pitch: 50
// };

// export function MapDataView(props){
//   const [settings, setSettings] = useState({
//     scrollZoom: true,
//     boxZoom: true,
//     dragRotate: true,
//     dragPan: true,
//     keyboard: true,
//     doubleClickZoom: true,
//     touchZoomRotate: true,
//     touchPitch: true,
//     minZoom: 0,
//     maxZoom: 20,
//     minPitch: 0,
//     maxPitch: 85
//   });

//   const updateSettings = useCallback(
//     (name, value) =>
//       setSettings(s => ({
//         ...s,
//         [name]: value
//       })),
//     []
//   );

//   return (
//     <>
//       <Map
//         initialViewState={initialViewState}
//         {...settings}
//         mapStyle="mapbox://styles/mapbox/dark-v9"
//         mapboxAccessToken={MAPBOX_TOKEN}
//       />
//       <ControlPanel settings={settings} onChange={updateSettings} />
//     </>
//   );
// }


import * as React from 'react';
import {useState, useMemo} from 'react';
import {render} from 'react-dom';
import Map, {
  Marker,
  Popup,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl
} from 'react-map-gl';

import ControlPanel from './MapLayoutControls';
import Pin from './MapPin';
import './map.css';

import CITIES from './MapCities.json';
const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGhhbmVlc2h0bmFpciIsImEiOiJjajN2OXU3b2IwMTRuMnlsYmRhandwdWV0In0.PhXxSGpmy4fXeO4tbfQ9Yg'; // Set your mapbox token here


export function MapDataView(props){
  const [popupInfo, setPopupInfo] = useState(null);

  const neighbours=props.similarityInfo.payload.data.split(",").map((v, i) => {
    const tv = v.split(":");
    return {
      outletcode:tv[0],
      latitude:tv[1],
      longitude:tv[2],
      score:(+tv[5]||0)*100
    }
  })
  const center = props.similarityInfo.payload.location;

  const pins = useMemo(
    () => {
        return <>
        <Marker
        key={`marker-root`}
        longitude={center[1]}
        latitude={center[0]}
        anchor="bottom"
        onClick={e => {
          // If we let the click event propagates to the map, it will immediately close the popup
          // with `closeOnClick: true`
          e.originalEvent.stopPropagation();
          setPopupInfo({outletcode:props.similarityInfo.outletcode,latitude:center[0],longitude:center[1]});
        }}
      >
        <Pin color="#0d0"/>
      </Marker>

      {(neighbours).map((city, index) => (
        <Marker
          key={`marker-${index}`}
          longitude={city.longitude}
          latitude={city.latitude}
          anchor="bottom"
          onClick={e => {
            // If we let the click event propagates to the map, it will immediately close the popup
            // with `closeOnClick: true`
            e.originalEvent.stopPropagation();
            setPopupInfo(city);
          }}
        >
          <Pin color="#00d"/>
        </Marker>
      ))
        }
      </>
      },
    []
  );

  return (
    <>
      <Map
        initialViewState={{
          latitude: center[0],
          longitude: center[1],
          zoom: 10,
          bearing: 0,
          pitch: 0
        }}
        mapStyle="mapbox://styles/mapbox/dark-v9"
        mapboxAccessToken={MAPBOX_TOKEN}
      >
        <GeolocateControl position="top-left" />
        <FullscreenControl position="top-left" />
        <NavigationControl position="top-left" />
        <ScaleControl />

        {pins}

        {popupInfo && (
          <Popup
            anchor="top"
            longitude={Number(popupInfo.longitude)}
            latitude={Number(popupInfo.latitude)}
            onClose={() => setPopupInfo(null)}
          >
            <div>
              Outlet: {popupInfo.outletcode}, | Score: {popupInfo.score} |{' '}
              {/* <a
                target="_new"
                href={`http://en.wikipedia.org/w/index.php?title=Special:Search&search=${popupInfo.city}, ${popupInfo.state}`}
              >
                Wikipedia
              </a> */}
            </div>
            <img width="100%" src={popupInfo.image} />
          </Popup>
        )}
      </Map>

      {/* <ControlPanel /> */}
    </>
  );
}
